import React from 'react'
import { useHistory, Link } from 'react-router-dom'
import FeatherIcon from 'feather-icons-react'
const NavIcon = ({ items }) => {
  let history = useHistory()
  let navIcons = false
  let backIcons = false
  if (items.icon) {
    const style = items.color ? { color: items.color } : {}

    if (items.iconType === 'icon') {
      if (items.iconSource === 'ckd') {
        navIcons = (
          <span style={{ display: 'contents' }}>
            <i
              className={`ckd-icon ckd-${items.icon} ml-1 mr-2`}
              style={{
                color: items.iconColor,
                margin: 0,
                fontSize: '18px',
              }}
            ></i>
          </span>
        )
      } else if (items.iconSource === 'feather') {
        navIcons = (
          <span
            style={{ width: '30px', display: 'inline-flex' }}
          >
            <FeatherIcon
              style={{ color: items.iconColor }}
              icon={items.icon}
              size="18"
            />
          </span>
        )
      } else if (items.iconSource === 'fas') {
        navIcons = (
          <span
            style={{
              width: '30px',
              display: 'inline-flex',
              alignItems: 'center',
            }}
          >
            <i
              className={`fas fa-${items.icon} mx-1`}
              style={{
                color: items.iconColor,
                fontSize: '16px',
              }}
            />
            {items.iconText ? items.iconText : ''}
          </span>
        )
      }else if (items.iconSource === 'healthicons') {
        navIcons = (
          <span
            style={{ width: '30px', display: 'inline-flex' }}
          >
            <i className={`healthicons-${items.icon}-outline`} style={{color:items.iconColor,fontSize:'24px'}}></i>
          </span>
        )
      }
    } else if (items.iconType === 'char') {
      navIcons = (
        <span className="pcoded-micon" style={{ ...style, width: 'auto' }}>
          <i
            className="ck-badge mx-1"
            style={{
              backgroundColor: items.iconColor,
              color: items.iconTextColor,
              fontSize: '18px',
              textAlign: 'center',
            }}
          >
            {items.iconText}
          </i>
        </span>
      )
    } else {
      navIcons = (
        <span className="pcoded-micon" style={style}>
          <i className={items.icon}>{items.iconText ? items.iconText : ''}</i>
        </span>
      )
    }
  }

  if (items.backIcon) {
    const backUrl = items.backUrl ? items.backUrl : '/'
    //onClick={()=>{history.push(backUrl);}}
    backIcons = (
      <Link to={backUrl} className="link-back-icon">
        <span className="pcoded-micon">
          <i className={items.backIcon}>
            {items.backIconText ? items.backIconText : ''}
          </i>
        </span>
      </Link>
    )
  }

  return (
    <React.Fragment>
      {backIcons}
      {navIcons}
    </React.Fragment>
  )
}

export default NavIcon
